import { FC, useState } from 'react';
import { MuiModal } from 'src/components/material/MuiModal';
// import toast from 'react-hot-toast';
import CircularProgress from '@mui/material/CircularProgress';
import { CommentMediaType, commentsApi } from 'src/api/comments';
import { CircleConstants } from 'src/api/constants/circle.constants';
import { UploadVideo } from 'src/components/common/Video/Video';
import MaterialTextField from 'src/components/material/textField';
import styles from './VideoModal.module.scss';

interface VideoModalProps {
  isOpenModal: boolean;
  setIsOpenModal: (open: boolean) => void;
  postId: string;
  onMediaUploaded: (fileId: string) => void;
  onCommentPosted?: (newComment: any) => void;
  isReply?: boolean;
  parentCommentId?: string;
}

export const VideoModal: FC<VideoModalProps> = ({
  isOpenModal,
  setIsOpenModal,
  postId,
  onMediaUploaded,
  onCommentPosted,
  isReply,
  parentCommentId,
}) => {
  const [videoError, setVideoError] = useState('');
  const [uploadedVideoId, setUploadedVideoId] = useState('');
  const [videoText, setVideoText] = useState('');
  const [isPosting, setIsPosting] = useState(false);

  const handleVideoUpdate = (fileId: string | File) => {
    if (typeof fileId === 'string') {
      setUploadedVideoId(fileId);
      setVideoError('');
      onMediaUploaded(fileId);
    }
  };

  const handleAddClick = async () => {
    if (!uploadedVideoId && videoText.trim() === '') {
      return;
    }

    try {
      setIsPosting(true);
      const newComment = await commentsApi.postComment(postId, {
        ...(videoText && { text: videoText }),
        ...(uploadedVideoId && {
          media_type: CommentMediaType.VIDEO,
          file_id: uploadedVideoId,
        }),
        ...(isReply && parentCommentId ? { parent_id: parentCommentId } : {}),
      });
      if (newComment && onCommentPosted) {
        onCommentPosted(newComment);
      }

      // toast.success(
      //   'We are uploading your video. Sometimes it can take a few minutes. Come back later!'
      // );

      setVideoText('');
      setUploadedVideoId('');
      setIsOpenModal(false);
    } catch (err) {
      setVideoError('Failed to send comment. Please try again.');
    } finally {
      setIsPosting(false);
    }
  };

  return (
    <MuiModal open={isOpenModal} setOpen={setIsOpenModal}>
      <UploadVideo
        defaultVideo=""
        onUpdate={handleVideoUpdate}
        helperText={`Upload a video (max ${CircleConstants.maxChallengeLengthInSeconds} seconds)`}
        commentType="video-comment"
        hideDesc
      />
      {videoError && <div className={styles.error}>{videoError}</div>}
      <MaterialTextField
        variant="outlined"
        color="primary"
        placeholder="Add comment"
        value={videoText}
        onChange={(e) => setVideoText(e.target.value)}
      />
      <button
        className={styles.btn}
        onClick={handleAddClick}
        disabled={isPosting || !uploadedVideoId}
        style={{ height: '36px' }}
      >
        {isPosting ? (
          <CircularProgress size={24} sx={{ color: 'white' }} />
        ) : (
          'Send'
        )}
      </button>
    </MuiModal>
  );
};
